import { render, staticRenderFns } from "./alt-icon.vue?vue&type=template&id=0d032b3e&scoped=true&"
import script from "./alt-icon.vue?vue&type=script&lang=ts&"
export * from "./alt-icon.vue?vue&type=script&lang=ts&"
import style0 from "./alt-icon.vue?vue&type=style&index=0&id=0d032b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d032b3e",
  null
  
)

export default component.exports